import { render, staticRenderFns } from "./ReportCod.vue?vue&type=template&id=71fe3835&scoped=true"
import script from "./ReportCod.vue?vue&type=script&lang=js"
export * from "./ReportCod.vue?vue&type=script&lang=js"
import style0 from "./ReportCod.vue?vue&type=style&index=0&id=71fe3835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe3835",
  null
  
)

export default component.exports